import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import './i18n';
import App from './App';
import "./index.css";
import "./custom.scss";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <ToastContainer />
  </>
);
